import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { CustomModal, RenderTableHeaderValue, RenderTableCellValue } from '../../../resusableComponents/common/formElements';
import ReactDataTable from '../../../resusableComponents/common/ReactDataTable';

const PreviewTemplateModal = ({ show, templateId, previewData, onHide, onEdit, onExport }) => {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (previewData && Array.isArray(previewData)) {
      setLoading(true);
      try {
        if (previewData.length > 0) {
          const headerRow = Object.keys(previewData[0]);
          
          const generatedColumns = headerRow.map((col, index) => ({
            name: <RenderTableHeaderValue value={col || `Column ${index + 1}`} />,
            selector: (row) => row[col] || "",
            cell: (row) => <RenderTableCellValue className="text-truncate" value={row[col] || ""} tooltip={true} />,
            sortable: false,
            minWidth: "150px"
          }));

          setColumns(generatedColumns);
          setData(previewData);
        } else {
          setColumns([]);
          setData([]);
        }
      } catch (e) {
        console.error("Error parsing preview data:", e);
      } finally {
        setLoading(false);
      }
    } else {
      setColumns([]);
      setData([]);
    }
  }, [previewData]);

  return (
    <CustomModal
      isOpen={show}
      size="xl"
      modalTitle={<FormattedMessage id="preview_template.modal.title" defaultMessage="Preview Template Data" />}
      onHide={onHide}
      onClose={onHide}
    >
      <div className="card">
        <div className="card-body">
          <div className="table-responsive custom-scroll">
            <ReactDataTable
              className="custom-scroll-460"
              columns={columns}
              data={data}
              progressPending={loading}
              pagination={true}
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 20, 50]}
            />
          </div>
          <div className="d-flex justify-content-end mt-4">
            <button className="btn btn-outline-secondary me-3 waves-effect" onClick={onHide}>
              <FormattedMessage id="btn.cancel" defaultMessage="Cancel" />
            </button>
            <button className="btn btn-primary me-3 waves-effect" onClick={() => onEdit(templateId)}>
              <FormattedMessage id="btn.edit" defaultMessage="Edit" />
            </button>
            <button className="btn btn-success waves-effect" onClick={() => onExport()}>
              <FormattedMessage id="btn.export" defaultMessage="Export" />
            </button>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default PreviewTemplateModal;
